<template>
  <el-dialog
    width="600px"
    v-dialogDrag
    :append-to-body="true"
    :visible.sync="operateTenantDialog.visible"
    title="编辑菜单"
    :close-on-click-modal="false"
    @closed="closeDialog"
  >
    <el-form ref="operateForm" :model="operateMenuForm" label-width="100px">
      <el-form-item label="当前名称" prop="title">
        <el-input size="small" clearable v-model="operateMenuForm.title" />
      </el-form-item>
      <el-form-item label="菜单图标">
        <el-select size="small" clearable filterable v-model="operateMenuForm.icon" class="w-full">
          <template slot="prefix">
            <i :class="operateMenuForm.icon"></i>
          </template>
          <el-option v-for="(item, index) in iconData" :key="index" :label="item" :value="item">
            <i :class="item"></i>
            <span class="m-l-5">{{ item }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item v-show="operateMenuForm.isShowCheckBox"
        label="是否首页"
        prop="title">
        <el-checkbox v-model="operateMenuForm.isHomeMenu"></el-checkbox>
      </el-form-item> -->
      <el-form-item label="菜单ID">
        <el-input size="small" clearable v-model="operateMenuForm.menuKey" readonly />
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button size="small" type="primary" class="iconfont icon-check" @click="save"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="closeDialog">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { TenantMenuApi } from '@wiz-api/eaf-tenant-management'
import axios from 'axios'
import { pick } from 'lodash'
const tenantMenuApiService = new TenantMenuApi()
export default {
  props: {
    operateTenantDialog: {
      type: Object,
      default: {
        visible: false,
      },
    },
    operateMenuForm: {
      type: Object,
      default: {
        title: '',
        icon: '',
        isShowCheckBox: false,
        isHomeMenu: false,
      },
    },
  },
  data() {
    return {
      iconData: [],
    }
  },
  watch: {},
  methods: {
    async getIconData() {
      const iconRes = await axios.get('/icon.json')
      this.iconData = JSON.parse(iconRes.data.icon)
    },
    save() {
      this.$emit('refreshTenantMenu', this.operateMenuForm)
      if (this.operateMenuForm.isHomeMenu) {
        this.$emit('refreshHomeMenuData', this.operateMenuForm)
      }
    },
    closeDialog() {
      this.$emit('closeOperateTenantDialog')
    },
  },
  created() {
    this.getIconData()
  },
}
</script>
